"use client";

import * as React from "react";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
interface FaqItem {
  id: string;
  question: string;
  answer: string;
}
const faqs: FaqItem[] = [{
  id: "item-1",
  question: "Do you deliver refrigerated trailers to Los Angeles?",
  answer: "Yes, we deliver to Los Angeles and Southern California. Delivery coverage is confirmed with each quote based on your location and trailer size."
}, {
  id: "item-2",
  question: "Can I rent the 53-foot reefer trailer in Los Angeles?",
  answer: "The 53-foot reefer may be considered for temporary cold-storage needs in Los Angeles. Availability, temperature requirements, power or fuel needs, loading, delivery, site access, duration, and suitability are confirmed individually with each quote."
}, {
  id: "item-3",
  question: "What power information should I provide for a Los Angeles rental?",
  answer: "Provide the available site power, if known. Power or fuel requirements vary by trailer and are confirmed individually with each quote. Requirements for the 53-foot reefer are confirmed separately."
}, {
  id: "item-4",
  question: "How is pricing determined?",
  answer: "Pricing is based on trailer size, rental dates, delivery location, site power availability, and optional add-ons. Your quote confirms final pricing."
}, {
  id: "item-5",
  question: "What if my location is outside Los Angeles?",
  answer: "Submit your delivery address with your quote request for individual review and coverage confirmation."
}];
export default function AngelesFaq() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll<HTMLElement>({
    threshold: 0.1
  });
  return <section id="losangelesfaq" ref={ref} data-nav="light" className="bg-background text-foreground py-16 sm:py-24 border-b border-border/60 transition-opacity duration-700 ease-out" style={{
    opacity: isVisible ? 1 : 0
  }}>
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 max-w-4xl">
        <h2 className="text-3xl sm:text-4xl font-semibold tracking-tight text-foreground text-center mb-10 sm:mb-14 font-default">
          Los Angeles FAQ
        </h2>

        <div className="bg-card text-card-foreground rounded-xl border border-border shadow-xs p-6 sm:p-8">
          <Accordion type="single" collapsible className="w-full">
            {faqs.map((faq, i) => <AccordionItem key={faq.id} value={faq.id} data-index={i} className="border-b border-border py-2 last:border-b-0">
                <AccordionTrigger className="text-left font-medium text-base sm:text-lg text-foreground hover:no-underline hover:text-primary transition-colors py-4">
                  {faq.question}
                </AccordionTrigger>
                <AccordionContent className="text-muted-foreground leading-relaxed text-sm sm:text-base pt-1 pb-4">
                  {faq.answer}
                </AccordionContent>
              </AccordionItem>)}
          </Accordion>
        </div>
      </div>
    </section>;
}